import { createBrowserRouter } from "react-router-dom";
import { Navigate } from "react-router-dom";
import ResetPassword from "../pages/login/ResetPassword";
import ForgotPassword from "../pages/login/ForgotPassword";
import Login_lms from "../pages/login/login_lms";
import Home from "../pages/homePage/Home";
import ContactUs from "../components/shared/contactUs/ContactUs";
import AboutUs from "../components/shared/aboutUs/AboutUs";
import AdminRoutes from "./AdminRoutes";
import AdminDashboard from "../pages/Admin/Dashboard/AdminDashboard";
import DomainPage from "../pages/Admin/DomainPage/AdminDomain";
import CoursesAdmin from "../components/admin/booksAdmin/CoursesAdmin";
import UsersAdmin from "../pages/Admin/usersAdmin/UsersAdmin";
import CategoriesAdmin from "../components/admin/categoriesAdmin/CategoriesAdmin";
import IssuanceAdmin from "../components/admin/issuanceAdmin/IssuanceAdmin";
import UserHistory from "../pages/Admin/userHistory/UserHistory";
import AllGroup from "../pages/Admin/Groups/GroupListing";
import ContentShowPage from "../components/user/myCourses/ContentShowPage";
import GroupHistory from "../pages/Admin/Groups/GroupHistory";

import CourseContentAdmin from "../pages/Admin/Courses/CourseContentAdmin";
import Quiz from "../pages/quiz/Quiz";
import QuizAttemptDetailsPage from "../pages/user/courses/QuizAttemptDetailsPage";
import UserRoutes from "./UserRoutes";
import UserDashboard from "../pages/user/dashboard/UserDashboard"
import CourseContentUser from "../pages/user/courses/CourseContentUser";
import UserGroupHistory from "../components/user/myGroups/UserGroupHistory";
import CourseQuizAttempt from "../pages/user/courses/CourseQuizAttempt";
import NotFound from "../pages/notFound/NotFound";
import SingleUserReport from "../components/admin/ReportPages/SingleUserReport";
import GroupUsersReport from "../pages/Admin/Groups/GroupUsersReport";
import SingleCourseReport from "../pages/Admin/Courses/SingleCourseReport";
import SingleGroupReport from "../pages/Admin/Groups/GroupReport/SingleGroupReport";
import CourseSingleReport from "../pages/Admin/Courses/CourseSingleReport";
import SingleBundleReport from "../pages/Admin/Curriculum/SingleBundleReport";
import FrequencyDashboard from "../components/admin/FrequencyFiles/FrequencyDashboard";
import BookHistory from "../components/admin/categoriesAdmin/CategoriesAdmin"
import AdminHOC from "../components/shared/HOC/AdminHOC";
import QuizReportDashboard from "../pages/Admin/QuizReport/QuizReportDashboard";
import QuizQuestionEditPage from "../pages/quiz/QuizQuestionEditPage";
import UserReportPage from "../pages/Admin/usersAdmin/UsersReport";
import CourseReport from "../pages/Admin/Courses/CoursesReport";
import App from "../App";
import MyCourses from "../pages/user/courses/MyCourses";
import ActiveCurriculum from "../pages/Admin/Curriculum/ActiveCurriculum";
import CurriculumHistory from "../pages/Admin/Curriculum/CurriculumHistory";
import CurriculumReport from "../pages/Admin/Curriculum/CurriculumReport";
import UserCourses from "../pages/Admin/Courses/UserCourses";
import UserAdminPage from "../pages/Admin/usersAdmin/UserAdminPage";
import GroupKpiReportTable from "../pages/Admin/Groups/GroupReport/GroupReportTable";
import Enrollments from "../pages/Admin/Enrollments/Enrollments";
import MyGroups from "../pages/user/groups/MyGroups";
import UserHistoryPage from "../pages/Admin/userHistory/UserHistoryPage";
import SingleContentReport from "../pages/Admin/Courses/SingleContentReport";
import ContentReport from "../pages/Admin/Courses/ContentReport";
import GroupUserHistory from "../pages/user/groups/GroupHistory";
const QuizReportWithHOC = AdminHOC(QuizReportDashboard);


 const router = createBrowserRouter([
  {
    path: "/login",
    element: <Login_lms />,
  },
  {
    path: "/Login_lms_plasma",
    element: <Login_lms />,
  },
  { path: "/forget-password", element: <ForgotPassword /> },
{ path: "/forget-password/:token", element: <ResetPassword /> },
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <Navigate to="/login" replace /> },
      { path: "contact", element: <ContactUs /> },
      { path: "about", element: <AboutUs /> },
      
      {
        path: "admin",
        element: (
          <AdminRoutes>
            <AdminDashboard />
          </AdminRoutes>
        ),
      },
      {
       path: "domain",
       element: (
        <AdminRoutes>
          <DomainPage />
        </AdminRoutes>
       )
      },
      {
        path: "books",
        element: (
          <AdminRoutes>
            <UserCourses />
          </AdminRoutes>
        ),
      },
      {
        path: "users",
        element: (
          <AdminRoutes>
            <UserAdminPage/>
          </AdminRoutes>
        ),
      },
      {
        path: "categories",
        element: (
          <AdminRoutes>
            <CategoriesAdmin />
          </AdminRoutes>
        ),
      },
      {
        path: "issuance",
        element: (
          <AdminRoutes>
            <IssuanceAdmin />
          </AdminRoutes>
        ),
      },
      {
        path: "users/user-history/:id",
        element: (
          <AdminRoutes>
            <UserHistoryPage/>
          </AdminRoutes>
        ),
      },
      {
        path: "book-history/:id",
        element: (
          <AdminRoutes>
            <BookHistory />
          </AdminRoutes>
        ),
      },
      {
        path: "enroll",
        element: (
          <AdminRoutes>
            <Enrollments />
          </AdminRoutes>
        ),
      },
      {
        path: "quiz-report",
        element: (
          <AdminRoutes>
            <QuizReportWithHOC />
          </AdminRoutes>
        ),
      },
      {
        path: "group",
        element: (
          <AdminRoutes>
            <AllGroup />
          </AdminRoutes>
        ),
      },
      {
        path: "bundles",
        element: (
          <AdminRoutes>
            <ActiveCurriculum/>
          </AdminRoutes>
        ),
      },
      {
        path: "group-history/:id",
        element: (
          <AdminRoutes>
            <GroupHistory />
          </AdminRoutes>
        ),
      },
      {
        path: "/group-users/:id",
        element: (
          <AdminRoutes>
            <GroupUsersReport />
          </AdminRoutes>
        ),
      },
      {
        path: "bundles-history/:id",
        element: (
          <AdminRoutes>
            <CurriculumHistory/>
          </AdminRoutes>
        ),
      },
      {
        path: "/books/course-content/:courseId",
        element: (
          <AdminRoutes>
            <CourseContentAdmin />
          </AdminRoutes>
        ),
      },
      {
        path: "/books/course-content/:courseId/single-report/:contentId",
        element: (
          <AdminRoutes>
            <SingleContentReport />
          </AdminRoutes>
        ),
      },
      {
        path: "/books/course-content/content-report/:contentId",
        element: (
          <AdminRoutes>
            <ContentReport />
          </AdminRoutes>
        ),
      },
      {
        path: "course-content/:courseId/view/:contentId",
        element: (
            <UserRoutes>
                <ContentShowPage /> 
            </UserRoutes>
          ),
      },
      
      { path: "course-content/:courseId/quizzes", element: <Quiz/> },
      {
        path: "course-content/:courseId/quizzes/edit-question/:questionId",
        element: <QuizQuestionEditPage />,
      },
      
      {
        path:"quiz-attempt-details",
        element:
            <QuizAttemptDetailsPage/>
      },
      {
        path: "user",
        element: (
          <UserRoutes>
            <UserDashboard />
          </UserRoutes>
        ),
      },
      {
        path: "my-courses",
        element: (
          <UserRoutes>
            <MyCourses />
          </UserRoutes>
        ),
      },
      {
        path: "my-groups",
        element: (
          <UserRoutes>
            <MyGroups />
          </UserRoutes>
        ),
      },
      {
        path: "my-courses/course-content-user/:courseId",
        element: (
          <UserRoutes>
            <CourseContentUser />
          </UserRoutes>
        ),
      },
      {
        path: "my-groups/group-user-history/:id",
        element: (
          <UserRoutes>
            <GroupUserHistory />
          </UserRoutes>
        ),
      },
      { path: "quiz/:courseId", element: <CourseQuizAttempt /> },
      { path: "*", element: <NotFound /> },
      {
        path: "/users/user-report",
        element: (
          <AdminRoutes>
            {" "}
            <UserReportPage />
          </AdminRoutes>
        ),
      },
      {
        path: "/user-report/:userId",
        element: (
          <AdminRoutes>
            {" "}
            <SingleUserReport />
          </AdminRoutes>
        ),
      },
      {
        path: "books/course-report",
        element: (
          <AdminRoutes>
            {" "}
            <CourseReport />
            
          </AdminRoutes>
        ),
      },
      {
        path: "books/course-report/:courseId",
        element: (
          <AdminRoutes>
            {" "}
            <CourseSingleReport/>
          </AdminRoutes>
        ),
      },
      {
        path: "/group-report",
        element: (
          <AdminRoutes>
            {" "}
            <GroupKpiReportTable />
          </AdminRoutes>
        ),
      },
      {
        path: "/group-report/:groupId",
        element: (
          <AdminRoutes>
            {" "}
            <SingleGroupReport />
          </AdminRoutes>
        ),
      },
      {
        path: "/bundles/bundle-report",
        element: (
          <AdminRoutes>
            {" "}
            <CurriculumReport/>
          </AdminRoutes>
        ),
      },
      {
        path: "/bundles/bundle-report/:bundleId",
        element: (
          <AdminRoutes>
            {" "}
            <SingleBundleReport />
          </AdminRoutes>
        ),
      },
      {
        path: "/frequency-dashboard",
        element: (
          <AdminRoutes>
            {" "}
            <FrequencyDashboard />
          </AdminRoutes>
        ),
      },
    ],
  },
]);
export default router;